import type { TableColumn } from "@glide/type-schema";
import { isTzAwareColumn } from "@glide/formula-specifications";
import { assertNever } from "@glideapps/ts-necessities";
import type { PluginTableColumn } from "./refilter";

export function convertColumnToPluginColumn(c: TableColumn): PluginTableColumn {
    const { name, displayName, type } = c;
    let pluginType: PluginTableColumn["type"] = "string";
    switch (type.kind) {
        case "string":
        case "email-address":
        case "emoji":
        case "markdown":
        case "phone-number":
        // Phone numbers are treated like strings internally.
        case "time":
            pluginType = "string";
            break;
        case "duration":
        case "number":
            pluginType = "number";
            break;
        case "boolean":
            pluginType = "boolean";
            break;
        case "array":
        case "table-ref":
            pluginType = "array";
            break;
        case "uri":
        case "image-uri":
        case "audio-uri":
            pluginType = "url";
            break;
        case "json":
            pluginType = "json";
            break;
        case "date":
        case "date-time":
            return { name, displayName, type: "dateTime", timezoneAware: isTzAwareColumn(c) ? true : undefined };
        default:
            return assertNever(type);
    }
    return { name, displayName, type: pluginType };
}
